// extracted by mini-css-extract-plugin
export default {"wrapper":"joD3z","wrapper__description":"jTk4N"};